import {createFileRoute} from '@tanstack/react-router'
import KotcLiveView from '../../kotc/KotcLiveView'

// Short shareable alias for /live/kotc/$kotc_uid.
export const Route = createFileRoute('/live/k/$kotc_uid')({
    component: RouteComponent,
})

function RouteComponent() {
    return <KotcLiveView />
}
